<script>
import ICONS from "./icons";

/**
 * Draws one icon from the shared set in `icons.js`.
 *
 * A render function rather than a template: the shapes are a data array of
 * `{ tag, attrs }`, and Vue 2 propagates the SVG namespace from the `svg` root down to
 * children created this way, so `path`/`circle`/`rect` render correctly without any
 * `v-html`.
 *
 * Icons inherit `currentColor`, so callers set colour and size with CSS as before.
 */
export default {
  name: "BaseIcon",

  props: {
    name: {
      type: String,
      required: true,
      validator: (value) => Object.prototype.hasOwnProperty.call(ICONS, value),
    },
    /** Stroke weight, for the few places the design thickens the outline. */
    width: { type: [Number, String], default: 2 },
    /** Icons are decorative by default; pass a label when one carries meaning alone. */
    label: { type: String, default: "" },
  },

  render(h) {
    const icon = ICONS[this.name];
    if (!icon) return null;

    const stroked = icon.stroke !== false;
    const attrs = {
      viewBox: icon.viewBox || "0 0 24 24",
      fill: stroked ? "none" : "currentColor",
      "aria-hidden": this.label ? null : "true",
      role: this.label ? "img" : null,
      "aria-label": this.label || null,
    };
    if (stroked) {
      attrs.stroke = "currentColor";
      attrs["stroke-width"] = this.width;
      attrs["stroke-linecap"] = "round";
      attrs["stroke-linejoin"] = "round";
    }

    return h(
      "svg",
      { attrs },
      icon.shapes.map((shape) => h(shape.tag, { attrs: shape.attrs }))
    );
  },
};
</script>
